(function() { window.GUID_8805f6bb_48b2_4a4e_aa83_5af03390cc63 = { getGuid: function() { return "8805f6bb-48b2-4a4e-aa83-5af03390cc63"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var VideoPlayerInternals;
        (function (VideoPlayerInternals) {
            class Elements {
                constructor(player) {
                    this.player = player;
                    this.timeDisplay = {
                        totalIsMoreThanOneHour: false,
                        container: null,
                        cursor: null,
                        total: null
                    };
                    this.progressContainer = player.$Control.find('.progress-container');
                    this.progressThumb = this.progressContainer.find('.progress-thumb');
                    this.buttons = player.buttons;
                    this.video = player.video;
                    this.controls = player.controls;
                    this.timeDisplay.container = player.$Control.find('.time-display');
                    this.timeDisplay.cursor = this.timeDisplay.container.find('.time-cursor');
                    this.timeDisplay.total = this.timeDisplay.container.find('.time-total');
                }
            }
            VideoPlayerInternals.Elements = Elements;
        })(VideoPlayerInternals = Controls.VideoPlayerInternals || (Controls.VideoPlayerInternals = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=VideoPlayer.Elements.pre.js.map
